module.exports = __webpack_public_path__ + "b40bb18fffb8fb5e64302dfbf26754c7.png";